

















import Vue, { PropType } from 'vue';
import NeonButton from '@/components/NeonButton.vue';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import SanitySimpleBlockContent from '@/models/sanitySchema/sanitySimpleBlockContent';
import Snake from '@/components/Snake.vue';

export default Vue.extend({
  name: 'DepartmentsPanel',
  components: {
    NeonButton,
    SanityBlockContent,
    Snake,
  },
  props: {
    mediaButtonText: String,
    mediaDepartmentText: Array as PropType<Array<SanitySimpleBlockContent>>,
    techButtonText: String,
    techDepartmentText: Array as PropType<Array<SanitySimpleBlockContent>>,
  },
  methods: {
    onMediaClick() {
      this.$router.push('/media');
    },
    onTechnologyClick() {
      this.$router.push('/teknologi');
    },
  },
});
